import React from 'react';

type WindowScrollingParams = {
  onScroll: () => void;
};

export const useWindowScrolling = ({ onScroll }: WindowScrollingParams) => {
  React.useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        // throttle the scroll event
        window.requestAnimationFrame(() => {
          onScroll();
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [onScroll]);
};
